import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarActions, MatSnackBarRef } from '@angular/material/snack-bar';
import { SafeHtmlPipe } from '@shared/pipes';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'sky-error-message',
  imports: [SafeHtmlPipe, MatIcon, TranslocoDirective, MatSnackBarActions, MatButton],
  templateUrl: './error-message.component.html',
  styles: `
    :host {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      flex-direction: row;

      .error-message {
        font-size: 14px;
        color: var(--app-primary-500);
      }

      .small-icon-button.mat-mdc-button {
        background-color: transparent;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessageComponent {
  public data: { status: number; message: string } = inject(MAT_SNACK_BAR_DATA);
  private readonly snackRef = inject(MatSnackBarRef<ErrorMessageComponent>);

  close(): void {
    this.snackRef.dismiss();
  }
}
